import gql from "graphql-tag";

export const GET_PACIENTES_BY_MEDICO = gql`
  query getPacientesByMedico($id: Int) {
    findMedicoBy(id: $id) {
      auxiliares {
        id
        nombre
        primer_apellido
        segundo_apellido
      }
      pacientes {
        id
        cognito_id
        dni
        nombre
        primer_apellido
        segundo_apellido
      }
    }
  }
`;

export const GET_PACIENTE_BY_ID = gql`
  query findPacienteBy($id: Int) {
    findPacienteBy(id: $id) {
      id
      cognito_id
      dni
      nombre
      primer_apellido
      segundo_apellido
      medicos {
        id
        nombre
        primer_apellido
        segundo_apellido
      }
    }
  }
`;

export const GET_ENCUESTAS_BY_PACIENTE_ID = gql`
  query findPacienteBy($cognito_id: String) {
    findPacienteBy(cognito_id: $cognito_id) {
      id
      cognito_id
      encuestas {
        id
        estado_encuesta {
          nombre
        }
        tipo_encuesta {
          id
          tipo
          descripcion
        }
        resultado
        color
        resultado_numerico
        fill_at
      }
    }
  }
`;

export const GET_PACIENTE_BY_COGNITO_ID = gql`
  query findPacienteBy($cognito_id: String) {
    findPacienteBy(cognito_id: $cognito_id) {
      id
      cognito_id
      dni
      nombre
      primer_apellido
      segundo_apellido
    }
  }
`;

export const GET_ALL_ENFERMEDADES = gql`
  query findAllEnfermedades {
    findAllEnfermedades {
      id
      nombre
      descripcion
    }
  }
`;

export const GET_TIPOS_VIA = gql`
  query findTiposVia {
    findTiposVia {
      id
      nombre
      descripcion
    }
  }
`;

export const GET_NIVELES_INSTRUCCION = gql`
  query findNivelesInstruccion {
    findNivelesInstruccion {
      id
      nombre
      descripcion
    }
  }
`;
